import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

interface OpenIdConfig {
  clientId: string;
  authority: string;
}

interface APIGatewayConfig {
  USER_ENDPOINT: string;
  SEARCH_ENDPOINT: string;
  EXPORT_ENDPOINT: string;
  OCP_APIM_SUBSCRIPTION_KEY: string;
}

@Injectable({
  providedIn: 'root'
})

export class EnvironmentConfigService {

  private static openIdConfig: OpenIdConfig;
  private static apiGatewayConfig: APIGatewayConfig;

  constructor() {
    // Initialize the static configuration only if it hasn't been initialized yet
    if (!EnvironmentConfigService.openIdConfig) {
      EnvironmentConfigService.initializeConfig();
    }
  }

  // Static method to initialize the configuration
  private static initializeConfig(): void {
    const hostname = window.location.hostname;

    if (hostname.includes('-d') || hostname === 'localhost') {
      EnvironmentConfigService.openIdConfig = {
        clientId: '3f839165-f922-4566-a9d3-45bcfbf98255',
        authority: 'https://login.microsoftonline.com/44bbd632-fe04-42d7-933e-2649dcd22649/v2.0'
      };
      EnvironmentConfigService.apiGatewayConfig = {
        //USER_ENDPOINT: 'http://localhost:8082/user',
        //SEARCH_ENDPOINT: 'http://localhost:8083/search',
        //EXPORT_ENDPOINT: 'http://localhost:8084/report',
        USER_ENDPOINT: 'https://apigtwd01.eu.tatasteel.com/downstream/coillab/dev/user',
        SEARCH_ENDPOINT: 'https://apigtwd01.eu.tatasteel.com/downstream/coillab/dev/search',
        EXPORT_ENDPOINT: 'https://apigtwd01.eu.tatasteel.com/downstream/coillab/dev/report',
        OCP_APIM_SUBSCRIPTION_KEY: environment.OCP_APIM_SUBSCRIPTION_KEY_DEV
      };
    } else if (hostname.includes('-t')) {
      EnvironmentConfigService.openIdConfig = {
        clientId: '579ee57c-51a8-4cce-a749-f8f93fcca0ea',
        authority: 'https://login.microsoftonline.com/44bbd632-fe04-42d7-933e-2649dcd22649/v2.0'
      };
      EnvironmentConfigService.apiGatewayConfig = {
        USER_ENDPOINT: 'https://apigtwd01.eu.tatasteel.com/downstream/coillab/test/user',
        SEARCH_ENDPOINT: 'https://apigtwd01.eu.tatasteel.com/downstream/coillab/test/search',
        EXPORT_ENDPOINT: 'https://apigtwd01.eu.tatasteel.com/downstream/coillab/test/report',
        OCP_APIM_SUBSCRIPTION_KEY: environment.OCP_APIM_SUBSCRIPTION_KEY_TEST
      };
    } 
    else {
      EnvironmentConfigService.openIdConfig = {
        clientId: '93d42fc3-5b25-4e36-9874-0755976bbfda',
        authority: 'https://login.microsoftonline.com/44bbd632-fe04-42d7-933e-2649dcd22649/v2.0'
      };
      EnvironmentConfigService.apiGatewayConfig = {
        USER_ENDPOINT: 'https://apigtw.eu.tatasteel.com/downstream/coillab/prod/user',
        SEARCH_ENDPOINT: 'https://apigtw.eu.tatasteel.com/downstream/coillab/prod/search',
        EXPORT_ENDPOINT: ' https://apigtw.eu.tatasteel.com/downstream/coillab/prod/report',
        OCP_APIM_SUBSCRIPTION_KEY: environment.OCP_APIM_SUBSCRIPTION_KEY_PROD
      };
    }
  }

  // Static method to get the OpenID configuration
  static getOpenIdConfig(): OpenIdConfig {
    if (!EnvironmentConfigService.openIdConfig) {
      EnvironmentConfigService.initializeConfig();
    }
    return EnvironmentConfigService.openIdConfig;
  }

  // Static method to get the OpenID configuration
  static getApiGatewayConfig(): APIGatewayConfig {
    if (!EnvironmentConfigService.apiGatewayConfig) {
      EnvironmentConfigService.initializeConfig();
    }
    return EnvironmentConfigService.apiGatewayConfig;
  }
}
